import React from 'react';

import Form from '$/components/ui/Form';
import UrlInput from '$/components/ui/Input/Basics/UrlInput';

import { InteractionAccordionPanelProps, InteractionModalComponentProps } from '../types';
import { PropertySettings } from '../Modals/InteractionPropertySettings';

export const useTestimonialSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = ({ interaction, mentions, creatingFromTemplate }) => {
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: {
        content: (
          <>
            <PropertySettings
              interaction={interaction}
              isCreating={Boolean(creatingFromTemplate || interaction.isNew)}
              titleFieldName='details.testimonial.quote'
            />
            <Form.FieldLabel title='Call to action link' className='mt-1e' />
            <Form.Field
              name='details.link'
              className='mb-0'
              component={<UrlInput placeholder='Enter URL' mentions={mentions} />}
            />
            <Form.FieldLabel title='Company link' className='mt-1e' />
            <Form.Field
              name='details.testimonial.companyLink'
              className='mb-0'
              component={<UrlInput placeholder='Enter URL' mentions={mentions} />}
            />
          </>
        ),
      },
    },
  ];
};
